import { ConfigService } from 'src/config/config.service';
import { Router } from '@angular/router';
import { Actions, Effect ,ofType} from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import * as AdmUsuarioActions from '../../../actions/';
import { switchMap, map, catchError, mergeMap } from 'rxjs/operators';
import { AppState } from 'src/app/store/app.reducer';
import { Store } from '@ngrx/store';
import { usuarioService } from 'src/app/services/SiicartAdm/usuarioAdm.service';
import { AdmUsersActionTypes } from '../../../actions/AdmSiicart/Usuarios/admUsuarios.actions';
import { Usuario } from 'src/app/models/SiicartAdm/Usuario.model';

@Injectable()
export class admUsuarioEffects {

  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    private UsuariosService: usuarioService,
    private config: ConfigService,
    private router: Router
  ) {}

  // effects go here
    @Effect()
    AdmGetUsers$: Observable<any> = this.actions$.pipe(
        ofType(AdmUsuarioActions.AdmUsersActionTypes.GET_ADM_USERS),
        switchMap((action: AdmUsuarioActions.AdmGetUsers) => {
            return this.UsuariosService.ObtenerUsuarios()
                .pipe(
                    map((resultado: Usuario) => {
                        return new AdmUsuarioActions.AdmSuscesUsers(resultado, 'ListUsuarios');
                    }),
                    catchError(error => of (new AdmUsuarioActions.AdmFailUsers({ error })))
                );
            }
        )
    );

    @Effect()
    AdmSetUsers$: Observable<any> = this.actions$.pipe(
        ofType(AdmUsuarioActions.AdmUsersActionTypes.SET_ADM_USERS),
        switchMap((action: AdmUsuarioActions.AdmSetUsers) => {
            return this.UsuariosService.AgrModfUsuario(action.DatosUsuario)
                .pipe(
                    map((resultado: any) => {
                        return new AdmUsuarioActions.AdmSuscesUsers(resultado, 'SetUser');
                    }),
                    catchError(error => of (new AdmUsuarioActions.AdmFailUsers({ error })))
                );
            }
        )
    );

    @Effect()
    AdmDeleteUsers$: Observable<any> = this.actions$.pipe(
        ofType(AdmUsuarioActions.AdmUsersActionTypes.DELETE_ADM_USERS),
        switchMap((action: AdmUsuarioActions.AdmDeleteUsers) => {
            return this.UsuariosService.EliminarUsuario(action.ObjDel)
                .pipe(
                    map((resultado: any) => {
                        return new AdmUsuarioActions.AdmSuscesUsers(resultado, 'DeleteUsers');
                    }),
                    catchError(error => of (new AdmUsuarioActions.AdmFailUsers({ error })))
                );
            }
        )
    );
}
